import SkeletonLoader from '@/components/SkeletonLoader';

const LessonBreakdownListSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse">
      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl p-5 border border-neutral-light-200 flex flex-col gap-4"
          >
            {/* Icon + Title */}
            <div className="flex items-center gap-2">
              <SkeletonLoader
                variant="rect"
                width={34}
                height={34}
                className="rounded-lg"
              />
              <SkeletonLoader width={100} height={20} />
            </div>

            {/* Assigned Date row */}
            <div className="flex justify-between">
              <SkeletonLoader width={90} height={16} />
              <SkeletonLoader width={70} height={16} />
            </div>

            {/* Due Date row */}
            <div className="flex justify-between">
              <SkeletonLoader width={60} height={16} />
              <SkeletonLoader width={70} height={16} />
            </div>

            {/* Progress */}
            <div className="flex flex-col gap-2">
              <div className="flex justify-between">
                <SkeletonLoader width={100} height={16} />
                <SkeletonLoader width={36} height={16} />
              </div>
              <SkeletonLoader height={8} className="rounded-full w-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LessonBreakdownListSkeleton;
